<template>
  <!-- Main navbar -->
  <div class="navbar navbar-dark navbar-expand-lg navbar-static">
    <div class="container-fluid">
      <div class="d-flex d-lg-none me-2">
        <button type="button" class="navbar-toggler sidebar-mobile-main-toggle rounded-pill">
          <i class="ph-list"></i>
        </button>
      </div>

      <div class="navbar-brand flex-1 flex-lg-0">
        <router-link to="/" class="d-inline-flex align-items-center">
          <!-- <img src="@/assets/images/logo_icon.svg" alt="" /> -->
          <!-- <img :src="this.userInfo.UserImage ?? `${require('@/assets/images/icons/face_default.png')}`" class="w-32px h-32px rounded-pill" alt="" style="background-color: white;" /> -->
          <!-- <img src="@/assets/images/icons/Origin_Horizontal.png" class="d-none d-sm-inline-block h-48px ms-3" alt="" style="background-color: white; border-radius: 2px; padding: 8px;" /> -->
          <img src="@/assets/images/icons/CentralAmerica.png" class="d-none d-sm-inline-block h-48px ms-3" alt=""
            style="filter: brightness(0) invert(1); border-radius: 2px; padding: 8px;" />
          <!-- <img
            src="@/assets/images/logo_text_light.svg"
            class="d-none d-sm-inline-block h-16px ms-3"
            alt=""
          /> -->
        </router-link>
      </div>

      <!-- Search Main -->
      <!-- <NavBarSearchComp></NavBarSearchComp> -->
      <!-- /search Main -->

      <ul class="nav flex-row justify-content-end align-items-center order-1 order-lg-2">
        <li class="nav-item ms-lg-2">
          <!-- Notification Button -->
          <!-- <NotificationButtonComp></NotificationButtonComp> -->
          <!-- /notification Button -->
        </li>

        <li class="nav-item nav-item-dropdown-lg dropdown ms-lg-2 me-2 mt-1" v-if="checkPermission(permissionEnums.PurchaseOrderApprover || permissionEnums.PurchaseRequestApprover)">
          <!-- Navbar User -->
          <NavBarNotificationComp></NavBarNotificationComp>
          <!-- /navbar User -->
        </li>
        <li class="nav-item nav-item-dropdown-lg dropdown ms-lg-2">
          <!-- Navbar User -->
          <NavBarUserComp></NavBarUserComp>
          <!-- /navbar User -->
        </li>
        <li class="nav-item nav-item-dropdown-lg dropdown ms-lg-2">
          <!-- Navbar User -->
          <NavBarComplexComp></NavBarComplexComp>
          <!-- /navbar User -->
        </li>
      </ul>
    </div>
  </div>
  <!-- /main navbar -->
</template>
<script>
// import NotificationButtonComp from "@/components/layoutComponents/NavBar/NotificationButtonComp.vue";
// import NavBarSearchComp from "@/components/layoutComponents/NavBar/NavBarSearchComp.vue";
import NavBarUserComp from "@/components/layoutComponents/NavBar/NavBarUserComp.vue";
import NavBarComplexComp from "@/components/layoutComponents/NavBar/NavBarComplexComp.vue";
import NavBarNotificationComp from "@/components/layoutComponents/NavBar/NavBarNotificationComp.vue";
import { permissionEnum } from "@/constants/permissionEnum";

export default {
  inject: ["permissionService"],
  components: {
    // NotificationButtonComp,
    // NavBarSearchComp,
    NavBarUserComp,
    NavBarComplexComp,
    NavBarNotificationComp
  },
  data() {
    return {
      permissionEnums: permissionEnum
    }
  },
  methods: {
    checkPermission(permission) {
      // return this.useAuthAppStore.getParsedToken?.perms?.includes(`${this.complexService.getInfoByCode(this.useAuthAppStore.getSelectedComplex)?.description}.${permission}`);
      return this.permissionService.checkPermissionsForOperations(permission);
    },
  },
};
</script>
<style></style>
